export default __webpack_public_path__ + "f0ca988f7acf33ae42bfb5bc3f92011b.png";